export { templateDetailsRoute } from './route'
